module.exports = __webpack_public_path__ + "static/media/video.d43ce2af.svg";